import { Service } from '../../models/Entities/Service';
import { CommonState } from '../common/state/commonState';

export interface ServiceState extends CommonState<Service> {
  // update all
  isUpdatingAll: boolean;
  isUpdatingAllSuccess: undefined | boolean;
  FailUpdatingAll: boolean;
  
  // saving
  isSaving: boolean;
  isSavingSuccess: undefined | boolean;
  failOnSaving: boolean;
  
  // adding
  isAdding: boolean;
  isAddingSuccess: undefined | boolean;
  failOnAdding: boolean;
  
  // deleting
  isDeleting: boolean;
  isDeletingSuccess: undefined | boolean;
  failOnDeleting: boolean;
  
  // filter
  isFiltered: boolean;
  filterCriteria: any | undefined;
  
  // selection
  selected: Service | undefined;
}

export const ServiceUnloadState: ServiceState = {
  // loading all
  isLoadingAll: false,
  successLoadingAll: undefined,
  failOnLoadingAll: false,

  // update all
  isUpdatingAll: false,
  isUpdatingAllSuccess: undefined,
  FailUpdatingAll: false,

  // loading one
  isLoadingOne: false,
  successLoadingOne: undefined,
  failOnLoadingOne: false,
  
  // adding new one (CommonState)
  isAddingNewOne: false,
  successAddingNewOne: undefined,
  failOnAddingNewOne: false,
  
  // updating one (CommonState)
  isUpdatingOne: false,
  successUpdatingOne: undefined,
  failOnUpdatingOne: false,
  
  // deleting one (CommonState)
  isDeletingOne: false,
  successDeletingOne: undefined,
  failOnDeletingOne: false,

  // saving
  isSaving: false,
  isSavingSuccess: undefined,
  failOnSaving: false,

  // adding
  isAdding: false,
  isAddingSuccess: undefined,
  failOnAdding: false,

  // deleting
  isDeleting: false,
  isDeletingSuccess: undefined,
  failOnDeleting: false,

  isFiltered: false,
  filterCriteria: undefined,

  list: [],
  selected: undefined,
  error: undefined
};
